import { Button, Card, Group, Text } from "@mantine/core";
import { useDisclosure, useForceUpdate } from "@mantine/hooks";
import { IconFilter, IconPlus } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import AddItemButton from "@/components/add-item-button";
import RefreshQueryButton from "@/components/refresh-query-button";
import { THandler } from "@/components/table/Table";
import FilterList from "@/components/table/TableFiltersList";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import GruposTable, {
  QUERY_KEY
} from "@/modules/grupos-diagnostico/components/grupos-diagnostico-table/GruposDiagnosticoTable";
import gruposDiagnosticoSchema from "@/modules/grupos-diagnostico/schema/grupos-diagnostico-schema";
import { ID_CADASTROS_GRUPOS_DE_PERGUNTAS } from "@/utils/constants";
import TableFilters from "./TableFilters";

const REFRESH_ALL_KEY = [QUERY_KEY];
const GruposDiagnosticosPage = () => {
  const tableHandlersReference = useRef<THandler<TGruposDiagnostico>>(null);
  const [opened, { close, toggle }] = useDisclosure(false);
  const queryClient = useQueryClient();

  const { create } = useGetAuthorizations(ID_CADASTROS_GRUPOS_DE_PERGUNTAS);

  const forceUpdate = useForceUpdate();
  /**
   * Handle filter applied
   */
  function handleFilterApplied() {
    close();
    void queryClient.invalidateQueries({ queryKey: REFRESH_ALL_KEY }).then(() => forceUpdate());
  }

  return (
    <Card
      withBorder
      shadow="md"
      styles={{
        section: {
          overflow: "auto"
        }
      }}
    >
      <Card.Section px="md" py="xs" withBorder>
        <Group justify="space-between">
          <Text fw={500} fz="lg">
            Listagem de grupos
          </Text>

          {create && (
            <Group>
              <AddItemButton
                size="sm"
                leftSection={<IconPlus size="1rem" />}
                modalProperties={{ modal: "grupos-diagnostico-form-modal", closeOnEscape: false }}
                schema={gruposDiagnosticoSchema}
              >
                Adicionar
              </AddItemButton>
            </Group>
          )}
        </Group>
      </Card.Section>
      <Card.Section inheritPadding py="md" withBorder>
        <Group justify="space-between">
          <Group align="center">
            <Button variant="subtle" size="compact-md" onClick={toggle} leftSection={<IconFilter size="1rem" />}>
              Filtros
            </Button>
            {tableHandlersReference.current && <FilterList filters={tableHandlersReference.current.filters} />}
          </Group>
          <RefreshQueryButton queryKey={REFRESH_ALL_KEY} />
        </Group>

        {tableHandlersReference.current && (
          <TableFilters
            table={tableHandlersReference.current.table}
            filters={tableHandlersReference.current.filters}
            onClose={close}
            onFilterApplied={handleFilterApplied}
            opened={opened}
          />
        )}
      </Card.Section>
      <GruposTable ref={tableHandlersReference} />
    </Card>
  );
};

GruposDiagnosticosPage.displayName = "GruposDiagnosticosPage";

export default GruposDiagnosticosPage;
